"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Paths_1 = require("../../constants/Paths");
const history_1 = require("../../helper/history");
const UserButtonDropdownItem_1 = __importDefault(require("./UserButtonDropdownItem"));
class UserButton extends react_1.default.Component {
    showDropdown = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showDropdown: mobx_1.observable,
            auth0: mobx_1.computed,
            userName: mobx_1.computed,
            userPicture: mobx_1.computed,
            onToggleDropdown: mobx_1.action.bound,
            onHideDropdown: mobx_1.action.bound,
        });
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onHideDropdown);
    }
    get auth0() {
        return this.props.auth0;
    }
    get userName() {
        return !!AuthorizationStore_1.default.user?.name ? AuthorizationStore_1.default.user?.name : (0, translation_1.t)('user_button.login');
    }
    get userPicture() {
        return !!AuthorizationStore_1.default.user?.picture
            ? { image: AuthorizationStore_1.default.user.picture }
            : { icon: Zupicons_1.default.user };
    }
    render() {
        const { className, onItemClick = noop_1.noop } = this.props;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-user-button', className), onClick: this.onClick },
            react_1.default.createElement(Button_1.default, { className: "znd-user-button__button", variant: ButtonVariant_1.default.light, ...this.userPicture }),
            react_1.default.createElement("span", { className: "znd-user-button__name" }, this.userName),
            this.showDropdown ? (react_1.default.createElement("div", { className: "znd-user-button__dropdown" },
                AuthorizationStore_1.default.hasScopes([
                    AuthorizationScopes_1.default.SHOP_READ,
                    AuthorizationScopes_1.default.PROFILE_READ,
                    AuthorizationScopes_1.default.ORDER_READ,
                ]) ? (react_1.default.createElement(UserButtonDropdownItem_1.default, { icon: Zupicons_1.default.history, onClick: (event) => {
                        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_USER_PROFILE_ORDERS);
                        onItemClick(event);
                    }, title: (0, translation_1.t)('user.profile.orders.title') })) : null,
                AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.PROFILE_READ) ? (react_1.default.createElement(UserButtonDropdownItem_1.default, { icon: Zupicons_1.default.user, onClick: (event) => {
                        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_USER_PROFILE_ACCOUNT);
                        onItemClick(event);
                    }, title: (0, translation_1.t)('user_button.profile') })) : null,
                react_1.default.createElement(UserButtonDropdownItem_1.default, { icon: Zupicons_1.default.signOut, onClick: (event) => {
                        this.auth0.logout({ returnTo: window.origin });
                        onItemClick(event);
                    }, title: (0, translation_1.t)('user_button.logout'), href: "#" }))) : null));
    }
    onToggleDropdown() {
        this.showDropdown = !this.showDropdown;
        setImmediate(() => {
            if (this.showDropdown) {
                document.addEventListener('click', this.onHideDropdown);
            }
            else {
                document.removeEventListener('click', this.onHideDropdown);
            }
        });
    }
    onHideDropdown() {
        this.showDropdown = false;
        document.removeEventListener('click', this.onHideDropdown);
    }
    onClick() {
        if (this.auth0.isAuthenticated) {
            return this.onToggleDropdown();
        }
        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_LOGIN, { returnTo: location.pathname });
    }
}
__decorate([
    bind_decorator_1.default
], UserButton.prototype, "onClick", null);
exports.default = (0, react_router_dom_1.withRouter)((0, auth0_react_1.withAuth0)((0, mobx_react_1.observer)(UserButton)));
